import React, { useMemo, useState } from 'react'
import { Breadcrumbs, Btn } from '../../../../AbstractElements'
import { Container, Row, Col, Card, CardBody, CardHeader, Input } from 'reactstrap'
import DataTable from 'react-data-table-component';
import ExpenseService from '../../../../Services/expenses/ExpenseService';
import { useQuery } from '@tanstack/react-query';
import AddExpenseModal from '../AddExpenseModal';


function MainExpenses() {
  const [modalOpen, setModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');

  const { isPending , isError, data, error } = useQuery({
    queryKey: ["inhouseExpenses"],
    queryFn: ExpenseService.getInhouseExpenses,
  });

  const { isPending:isCategoriesPending, isError:isCategoriesError, data:categories, error:categoryError } = useQuery({
    queryKey: ["inhouseCategories"],
    queryFn: ExpenseService.getInhouseCategories,
  });

  const rows = useMemo(() => {
    const list = Array.isArray(data?.data) ? data.data : [];
    const q = searchTerm.trim().toLowerCase();
    return list
      .map((expense) => ({
        id: expense.id,
        title: expense.title,
        artistId: expense.artist_id ?? '—',
        labelId: expense.label_id ?? '—',
        category: expense.category_inhouse || expense.category || '—',
        amount: expense.amount,
        currencies: expense.currencies,
        file: expense.file || '—',
        states: expense.status || '—',
      }))
      .filter((row) => {
        if (categoryFilter && String(row.category) !== String(categoryFilter)) return false;
        if (!q) return true;
        return (
          String(row.title || '').toLowerCase().includes(q) ||
          String(row.category || '').toLowerCase().includes(q) ||
          String(row.amount || '').toLowerCase().includes(q) ||
          String(row.labelId || '').toLowerCase().includes(q)
        );
      });
  }, [data, searchTerm, categoryFilter]);

  if (isCategoriesPending || isPending) {
    return 'Loading...';
  }
  
  if (isCategoriesError || isError) {
    return <p>An error has occurred: {categoryError?.message || error?.message}</p>;
  }

  const tableColumns = [
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "Label ID",
      selector: (row) => row.labelId,
      sortable: true,
    },
    {
      name: "Artist ID",
      selector: (row) => row.artistId,
      sortable: true,
    },
    {
      name: "Category",
      selector: (row) => row.category,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      sortable: true,
    },
    {
      name: "Currencies",
      selector: (row) => row.currencies,
      sortable: true,
    },
    {
      name: "File",
      selector: (row) => row.file,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.states,
      sortable: true,
    },
  ];

  return (
    <>
     <AddExpenseModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(false)}
        variant="inhouse"
      />
     <Breadcrumbs
        parent="Expenses"
        title="Expenses"
        mainTitle="In-House Expenses"
        buttons={[
          <Input
            type="select"
            name="select"
            id="exampleSelect"
            className='form-control'
            value={categoryFilter}
            onChange={(e) => setCategoryFilter(e.target.value)}
          >
          <option value="">Filter By Category</option>
          {(categories?.data || []).map((category) => (
            <option key={category.id} value={category.title}>{category.title}</option>
          ))}
        </Input>,
          <Btn
          attrBtn={{
            size: "sm",
            color: "primary",
            onClick: () => setModalOpen(true),
          }}
        >
          Add Expense
        </Btn>,
      
        ]}
      />

<Container fluid={true}>
      <Row>
        <Col sm="12">
          <Card>
            <CardHeader>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h5>In-House Expenses Table</h5>
                <Input
                  type="text"
                  placeholder="Search by title, category, amount, or label"
                  className="form-control rd-fluid-search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </CardHeader>
            <CardBody>
              <div className="expenses-table-wrap">
                <DataTable
                  columns={tableColumns}
                  data={rows}
                  striped={true}
                  center={true}
                  responsive={true}
                  pagination
                  noDataComponent="No in-house expenses found."
                />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
    
    </>
  )
}

export default MainExpenses
